import React, { useEffect, useState } from "react";
import CollectorDetailsForm from "./CollectorDetails";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import AuditableInfoButton from "../../../../components/common/form/AuditableInfoButton";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import { FaTrash } from "react-icons/fa6";
import IconButton from "../../../../components/common/form/IconButton";
import ModalButton from "../../../../components/common/form/ModalButton";
import { useDeleteCollectorByIdMutation, useGetCollectorByIdQuery } from "../collector";
import { Routes as AppRoutes } from "../../../../routes";
import { useGetJurisdictionsByCollectorIdQuery } from "../../jurisdiction/jurisdictionApi";
import JurisCollectorUpdateForm from "../modal/JurisCollectorUpdateForm";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

const CollectorDetailPage = () => {

  let { collectorId } = useParams();

  const [crumbs, setCrumbs] = useState<any[]>([])
  const collectorData = useGetCollectorByIdQuery(collectorId);
  const [deleteApi, { isLoading }] = useDeleteCollectorByIdMutation();
  const [showJurisCollectorUpdateModal, setShowJurisCollectorUpdateModal] = useState(false);

  const collectorJurisData = useGetJurisdictionsByCollectorIdQuery(collectorId);


  const navigate = useNavigate();

  useEffect(() => {

    setCrumbs([
      { content: "Home", url: "/home" },
      { content: "Collectors", url: "/collectors" },
      { content: "Collector Details", url: "" }
    ])

  }, []);

   useEffect(() => {
          document.title = 'Collector Details';
  
      }, []);

  const handleDelete = async () => {
    if (collectorJurisData.data && collectorJurisData.data.length > 0) {
      setShowJurisCollectorUpdateModal(true)
    }
    else {
      if (collectorId) {
        await deleteApi(collectorId).unwrap();
      }
      navigate(AppRoutes.Collector.path)
    }
  };

  return (
    <>
      <div className="px-5 py-5" >
        <div className={"justify-between sm:block md:flex lg:flex"}>
          <Breadcrumb crumbs={crumbs} />
          <div className={"justify-between sm:block md:flex lg:flex"}>
            {collectorJurisData?.data && hasPermission(["COLL-D"]) && collectorData?.data?.deleted === false &&
              <ModalButton
                triggerButton={
                  <IconButton
                    icon={<FaTrash />}
                    title={"Delete Collector"}
                    hasBackground={true}
                    className="mr-2"
                  />
                }
                modal={
                  <ConfirmationModal
                    show={true}
                    setShow={() => {
                    }}
                    title={"Delete Collector"}
                    bodyMessage={"Are you sure you want to delete this Collector?"}
                    onSubmit={() => handleDelete()}
                    isLoading={isLoading}
                  />
                }
              />}
            {collectorJurisData.data && collectorData?.data?.deleted === false &&
              hasPermission(["AUDIT-V"]) &&
              <AuditableInfoButton obj={collectorData.data} />}
          </div>
        </div >
        <CollectorDetailsForm />

        {showJurisCollectorUpdateModal && <JurisCollectorUpdateForm show={showJurisCollectorUpdateModal}
          setShow={setShowJurisCollectorUpdateModal} collectorJurisData={collectorJurisData} deleteTobeCollectorId={collectorId} />
        }
      </div>
    </>
  );
};

export default CollectorDetailPage;